import { useMutation } from '@tanstack/react-query';
import { diagnosticService } from '../services';

export function useGenerateReport() {
  const mutation = useMutation({
    mutationFn: () => diagnosticService.generateReport(),
  });

  return {
    generateReport: mutation.mutate,
    isGenerating: mutation.isPending,
    reportData: mutation.data,
  };
}
